module.exports = __webpack_public_path__ + "img/arrow-right.bf50863f.svg";